<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <Packs type="2"></Packs>
  </div>
</template>

<script>
import Packs from "@/components/Packs";
import { entering } from "@/mixins/entering";

export default {
  name: "enteringsubsidies",
  components: {
    Packs
  },
  mixins: [entering],
  created() {
    document.title = this.$t("enteringsubsidies.title");
  }
};
</script>
